import BasicLayout from '../layouts/BasicLayout';
import Home from '../pages/Home/Home';
import History from '../pages/History/History';
import Refund from '../pages/Refund/Refund';
import Login from '../pages/Login/Login';
import Verify from '../pages/Login/OTPVerify';

export default [
  {
    path: '/home',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      // {
      //   path: '*',
      //   element: <NotFound />,
      // },
    ],
  },

  {
    path: '/refund',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Refund />,
      },
    ],
  },

  {
    path: '/history',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <History />,
      },
    ],
  },

  {
    path: '/',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Login />,
      },
    ],
  },
  {
    path: '/verify',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Verify />,
      },
    ],
  },
];
